import type { Filter } from '../../_types/Car';

export default function getSearchFromFilterIdString(filterIdString: string): Filter {
    const booleanFilters = ['aktion', 'NFZ', 'sofort'];
    const multipleFilters = [
        'akttypList',
        'aufbauten',
        'EZ',
        'Farben',
        'fd',
        'ia',
        'idFirma',
        'ignoreFirma',
        'ignoreStandort',
        'kategorie',
        'KM',
        'Leistung',
        'motoren',
        'Ort',
        'Preis',
        'Rate',
        'Standort',
        'StandortQuelle',
    ];
    const numberFilters = [
        'akttypList',
        'aufbau',
        'aufbauten',
        'EZ',
        'EZVon',
        'EZBis',
        'Farben',
        'fd',
        'Getriebe',
        'hersteller0',
        'idFirma',
        'ignoreFirma',
        'ignoreStandort',
        'kategorie',
        'KM',
        'KMVon',
        'KMBis',
        'Leistung',
        'LeistungVon',
        'LeistungBis',
        'modell0',
        'MotorG',
        'motoren',
        'nfzHersteller',
        'moreCars',
        'pageSize',
        'Preis',
        'PreisVon',
        'PreisBis',
        'Rate',
        'RateVon',
        'RateBis',
        'siegel',
        'Standort',
        'StandortQuelle',
    ];

    const filterIdArray = filterIdString?.replace('?', '')?.split('&');
    const newFilerObject = {};

    for (let i = 0; i < filterIdArray?.length; i++) {
        const [key, value] = filterIdArray[i].split('=');
        let finalValue: string | string[] | number | number[] | boolean;

        if (value.includes(',')) {
            finalValue = value.split(',');
            // Make sure string-numbers are parsed to "true" numbers
            if (numberFilters.includes(key)) {
                for (let i = 0; i < finalValue.length; i++) {
                    // @ts-expect-error
                    finalValue[i] = parseInt(finalValue[i]);
                }
            }
        } else {
            if (numberFilters.includes(key)) {
                finalValue = parseInt(value);
            } else if (booleanFilters.includes(key)) {
                // Convert string "true" and "false" to their boolean values
                finalValue = value === 'true';
            } else {
                finalValue = value;
            }

            // Place value in array where selecting multiple values is possible
            if (multipleFilters.includes(key)) {
                finalValue = [finalValue as number];
            }
        }

        newFilerObject[key] = finalValue;
    }

    return newFilerObject;
}
